import { defineMessages } from 'react-intl';

export default defineMessages({
    imTooltip: {
        id: 'fnol.common.views.policyList.imTooltip',
        defaultMessage: 'When selecting the line of business for your claim submission, please note that Inland Marine policies typically cover specifically schedule equipment, valuable tools, materials in transit or stored away from your business location as well as Builders Risk. If you are unsure, please contact your agent.'
    },
})